import React, { Component, PureComponent } from 'react';
import * as Progress from 'react-native-progress';
import LottieView    from 'lottie-react-native';
import { StyleSheet, View, TextInput, ActivityIndicator, TouchableOpacity, ScrollView, Platform, Modal } from 'react-native';
import { Screen, Button, Input, Text, Routes, Line, Icon } from '../components';
import { PetAddScreen } from '../containers';
import { ArrayUtils, StringUtils, ArticleUtils } from '../utils';
import PetController          from '../controllers/petController';
import ConsultationController from '../controllers/consultationController';
import AnalyticsController    from '../controllers/analyticsController';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { WebView } from 'react-native-webview';
import AsyncStorage from '@react-native-async-storage/async-storage';

class ArticleDisplayScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      article_elements: null,
      articles: [],
      display_webview: false,
      webview_url: 'webview_url',
      article_engagement_id: ''
    }
  }

  async componentWillUnmount() {
    if (this.state.article_engagement_id) {
      let article_tracking_params = {
        article_engagement_id: this.state.article_engagement_id,
        has_closed: true
      }
      await AnalyticsController.updateArticleEngagement(article_tracking_params);
    }
  }

  async componentDidMount() {

    // console.log('this.props.article_id', this.props.article_id)
    // console.log('this.props', this.props)

    let article_id       = this.props.article_id     || '';
    let article_data     = this.props.article        || {};
    let content_html     = article_data.content_html || '';
    let article_elements = [];

    let article_engagement_id = '';

    if (content_html) {
      article_elements = this.get_content_elements(content_html);
    } else if (article_id && !content_html) {
      let content_from_stored = await this.get_content_from_stored(article_id);
      if (content_from_stored.article && content_from_stored.ui_elements && content_from_stored.ui_elements.length > 0) {
        article_elements = content_from_stored.ui_elements;
        article_data     = content_from_stored.article;
      }
    }

    if (!content_html && article_id && article_elements && article_elements.length === 0) {
      let article_response = await ConsultationController.getArticle(article_id);
      let article          = article_response && article_response.success && article_response.data && article_response.data.article ? article_response.data.article : {};
      let a_content_html   = article && article.content_html ? article.content_html : '';
      if (a_content_html) {
        article_data     = article;
        article_elements = this.get_content_elements(a_content_html);
      }
    }

    if (article_data && article_data.article_id) {
      let article_tracking_params = {
        category_tags: article_data.category_tags,
        article_id: article_data.article_id,
        article_url: article_data.url,
      }

      let article_eng_res   = await AnalyticsController.updateArticleEngagement(article_tracking_params);
      let engagement_id     = article_eng_res && article_eng_res.article_engagement_id ? article_eng_res.article_engagement_id : '';
      article_engagement_id = engagement_id;
    }

    this.setState({ article_id: article_id, content_html: content_html, article_elements: article_elements, article: article_data, article_engagement_id: article_engagement_id });
  }

  render_article_title = () => {
    let article = this.state.article || {};
    let title   = article.title      || '';
    let author  = article.author     || '';

    if (!title) {
      return null;
    }

    return <View style={{ padding: 20, paddingBottom: 0 }}>
      <Text style={{ fontSize: 26, fontWeight: '500', color: '#112268' }}>{ title }</Text>
      <Text style={{ marginTop: 5, fontSize: 16, color: '#112268' }}>{ 'By ' + author }</Text>
    </View>
  }

  render() {
    let article = this.state.article || {};
    let article_url = article.url    || '';

    return (
      <Screen navigation={this.props.navigation} title={'DodoVet'} style={{  }}>
          <WebView
            mediaPlaybackRequiresUserAction={true}
            style={{ backgroundColor: 'white', height: 200 }}
            source={{ uri: article_url }} />
      </Screen>
    );

    /*
    return (
      <Screen navigation={this.props.navigation} title={'Article Page'} scroll={true}>
        <View style={{ flex: 1, height: '100%' }}>
          { this.render_article_title() }
          { this.state.article_elements }
          { this.render_webview_modal() }
        </View>
      </Screen>
    );
    */
  }

  render_webview_modal = () => {
    return <Modal
      animationType="slide"
      transparent={true}
      visible={ this.state.display_webview }
      onRequestClose={() => {
        this.setState({ display_webview: false, webview_url: '' })
      }}>
        <Screen navigation={this.props.navigation} title={'Opened Link'} right_action={ () => { this.setState({ display_webview: false, pdf_url: '' }) }} modal={true}>
          <WebView
            style={styles.pdf_view_container}
            source={{ uri: this.state.webview_url }}
          />
        </Screen>
    </Modal>
  }

  open_web_view = (web_url) => {
    if (web_url) {
      this.setState({ webview_url: web_url, display_webview: true });
    }
  }

  get_content_elements = (article_content) => {
    let HTML = require('html-parse-stringify')
    let ast  = HTML.parse(article_content)
    let react_native_elements = ArticleUtils.getReactNativeElements(ast, this.open_web_view);
    return react_native_elements;
  }

  get_content_from_stored = async (article_id) => {
    let sects        = await AsyncStorage.getItem('user_article_sections');
    let sects_JSON   = JSON.parse(sects)
    let sections     = sects_JSON;
    let article      = {};
    let content_html = '';

    sections.every((section) => {
      let articles = [ ...section.articles ] || [];
          articles = articles.filter((art) => { return art.article_id === article_id });

      if (articles.length === 1 && articles[0] && articles[0].content_html) {
        article      = articles[0];
        content_html = article.content_html;
        return false;
      }

      return true;
    });

    if (content_html) {
      return {
        article: article,
        ui_elements: this.get_content_elements(content_html)
      }
    } else {
      return [];
    }
  }

}

function ArticleDisplayScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <ArticleDisplayScreen_Base {...props} navigate={navigate} />
  } else {
    let params       = props.route.params;
    let article_id   = params.article_id;
    let article      = params.article;
    return  <ArticleDisplayScreen_Base {...props} article_id={article_id} article={article} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({
  pdf_view_container: {
    flex: 1
  }
});

export default ArticleDisplayScreen
